module.exports = __webpack_public_path__ + "static/media/mk2_pic-2_cropped.cc5c73b0.jpg";